import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxJsonLdModule } from '@ngx-lite/json-ld';
import { SocialLoginModule, AuthServiceConfig, LoginOpt } from 'angularx-social-login';
import { GoogleLoginProvider, FacebookLoginProvider } from 'angularx-social-login';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { GuidedTourComponent, GuidedTourModule, GuidedTourService } from 'ngx-guided-tour';
import { SharedModule } from './shared/shared.module';
import { Shared2Module } from './shared/shared2.module';

import { ExitPopUpComponent } from './components/exit-pop-up/exit-pop-up.component';
import { ScreenGuideComponent } from './components/artist-dashboard/screen-guide/screen-guide.component';

import { AuthInterceptor } from './auth.interceptor';
import { DistributionGuideComponent } from './components/distribution-guide/distribution-guide.component';
import { MasterclassComponent } from './components/masterclass/masterclass.component';

const fbLoginOptions: LoginOpt = {
    scope: 'email',
    return_scopes: true,
    enable_profile_selector: true
};

const config = new AuthServiceConfig([
    {
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider('513395809723-70me9h0dmofcf8bk5oiibrt50fdef59p.apps.googleusercontent.com')
    },
    {
        id: FacebookLoginProvider.PROVIDER_ID,
        provider: new FacebookLoginProvider('335931163095578', fbLoginOptions)
    }
]);

export function provideConfig() {
    return config;
}

@NgModule({
    declarations: [
        AppComponent,
        ExitPopUpComponent,
        ScreenGuideComponent,
        DistributionGuideComponent,
        MasterclassComponent,
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        AppRoutingModule,
        BrowserAnimationsModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        SharedModule,
        Shared2Module,
        NgxJsonLdModule,
        SocialLoginModule,
        HttpClientModule,
        GuidedTourModule.forRoot(),
    ],
    providers: [
        GuidedTourService, GuidedTourComponent,
        {
            provide: AuthServiceConfig,
            useFactory: provideConfig
        }, {
            provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
